import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'neo-matris-checkbox',
  templateUrl: './matris-checkbox.component.html',
  styleUrls: ['./matris-checkbox.component.scss']
})
export class MatrisCheckboxComponent {
  @Input() checkboxLabel: any;
  @Input() checked: boolean;
  @Input() disabled: boolean = false; 
  @Output() checkedChange: EventEmitter<boolean> = new EventEmitter<boolean>();
}
